if (!customElements.get('show-more-button')) {
    customElements.define('show-more-button', class extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('.description-content');
        this.button = this.querySelector('button');
        this.isExpanded = false;
  
        this.button.addEventListener('click', () => this.expandShowMore());
      }
  
      expandShowMore() {
        this.isExpanded = !this.isExpanded;
        this.content.classList.toggle('expanded', this.isExpanded);
        this.button.textContent = this.isExpanded ? this.button.dataset.showLess : this.button.dataset.showMore;
        this.button.classList.toggle('button-show-less', this.isExpanded);
      }

      
    });
}